import { PublicClientApplication, Configuration } from '@azure/msal-browser'

const msalConfig: Configuration = {
    auth: {
        clientId: process.env.REACT_APP_CLIENTID as string,
        authority: "https://login.microsoftonline.com/" + process.env.REACT_APP_TENANTID,
        redirectUri: window.location.origin,
    },
    cache: {
        cacheLocation: 'sessionStorage',
        storeAuthStateInCookie: false
    }
}

export const msalInstance = new PublicClientApplication(msalConfig)

export const initializeMsal = async () => {
    await msalInstance.initialize();
}

export const loginRequest = {
    scopes: ['openid', 'profile', 'User.Read']
}

export const silentRequest = {
    scopes: ['openid', 'profile', 'User.Read'],
    forceRefresh: false
}
